module.exports = __webpack_public_path__ + "img/2.b22d6bb2.png";